import { FullStory, isInitialized } from "@fullstory/browser";

export enum AnalyticEvents {
  clapsAfterTransfer = "Claps After Transfer",
  unableToConnectAccount = "Unable to connect account",
}

export enum HeapEventAction {
  clicked = "Clicked on",
  landed = "Landed on page",
  completed = "Completed",
  uploaded = "Uploaded document",
  createdAccount = "Created account",
  verifiedAccount = "Verified account",
  useCalculator = "Used calculator",
  chatWithHenry = "Chat with Henry",
}

const Analytics = {
  track: ({ action, buttonName, screen }: { action: HeapEventAction; buttonName?: string; screen: string }): void => {
    const eventName = `${action} ${buttonName || ""} - ${
      screen.charAt(0).toUpperCase() + screen.slice(1).toLowerCase()
    }`;
    window.heap.track(eventName);
    if (
      isInitialized() &&
      action !== HeapEventAction.landed &&
      action !== HeapEventAction.createdAccount &&
      buttonName !== "Sign up"
    ) {
      FullStory("trackEvent", {
        name: `B2C - ${eventName}`,
        properties: {},
      });
    }
  },
  clickSignUp: ({ vendor }: { vendor: string }) => {
    if (isInitialized()) {
      FullStory("trackEvent", {
        name: `B2C - Clicked sign up on welcome page`,
        properties: {
          partner: vendor,
        },
      });
    }
  },
  createAccount: ({ vendor }: { vendor: string }) => {
    if (isInitialized()) {
      FullStory("trackEvent", {
        name: `B2C - Created account`,
        properties: {
          partner: vendor,
        },
      });
    }
  },
  landOnWelcomePage: ({ vendor }: { vendor: string }) => {
    if (isInitialized()) {
      FullStory("trackEvent", {
        name: `B2C - Landed on welcome page`,
        properties: {
          partner: vendor,
        },
      });
      let userProperties: Record<string, string> = {
        app: "b2c",
      };
      if (vendor) {
        userProperties = {
          ...userProperties,
          partner: vendor,
          landingPage: vendor,
        };
      }
      FullStory("setProperties", {
        type: "user",
        properties: userProperties,
      });
    }
  },
  recordEvent: (eventName: AnalyticEvents) => {
    window.heap.track(eventName);
  },
  clap: ({ count }) => {
    window.heap.addEventProperties({
      "Claps After Transfer": count,
    });
  },
  addUserProperties: (props) => {
    window.heap.addUserProperties(props);
    if (isInitialized()) {
      FullStory("setProperties", {
        type: "user",
        properties: { ...props, app: "b2c" },
      });
    }
  },
  identify: (email: string) => {
    window.heap.identify(email);
    if (isInitialized()) {
      FullStory("setIdentity", {
        uid: email.toLowerCase(),
      });
    }
  },
  setProperties: ({ entity, properties }: { entity: any; properties: Record<string, string> }) => {
    if (isInitialized()) {
      FullStory("setPropertiesAsync", {
        type: entity,
        properties,
      });
    }
  },
  trackEvent: (eventName: string) => {
    window.heap.track(eventName);
    if (isInitialized()) {
      FullStory("trackEvent", {
        name: `B2C - ${eventName}`,
        properties: {},
      });
    }
  },
};

export default Analytics;
